import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _, { set, get, isEmpty, flatMap, isEqual, cloneDeep, isArray } from 'lodash';
import * as Action from '../../../ProductCosting/store/ProductCosting.action';
import { averageCostingFieldpath, quantitiesFieldpath, testingFieldpath, landedInfoFieldPath, additionalFieldPath } from '../../../ProductCosting/fieldPath';
import {
  calculateTotValues,
  createDynamicGroupedArray,
  cloneData,
  checkArray,
  roundOff,
  roundingOff,
  convertedCurrValue,
  checkIsNanAndNumber,
} from '../../../../../Components/helper';
import * as action from '../../../../Library/CostingTemplateTSX/store/costingTemplate.actions';

export default function useDetailedPageHook(productInfoObj) {
  const dispatch = useDispatch();
  const {
    MultiProductSelectReducer: { productDetails, TestingLibraries, bomCompoList, productLengths, productExchnageRate },
  } = useSelector((reduxState) => reduxState);

  const { productCostingstate, setProductCostingState, initialSetting, internalState, grandTotalState } = productInfoObj;

  const {
    colourwayOptionsArr,
    sizeOptionsArr,
    detailedCosting: { detailedCostingActive },
    productInfo: { supplierId },
    productTemplate,
    isBreakdown,
  } = productCostingstate;
  const { grandTotal } = grandTotalState;

  const calculateAvrageCosting = async (copyState) => {
    const totLength = [];
    const totSize = [];
    const totColourways = [];
    const updatedArray = copyState?.averageCosting?.averageCostingInfo?.map((parentData) => {
      const expandArray = parentData?.expandData;
      let sumOfTotalPrice = '0';
      let sumOfQuantityPerSizCol = '0';
      let sumPricePerUnit = '0';
      let totWeightagePricePerUnit = '0';
      let totalQuantity = '0';
      if (isBreakdown) {
        parentData?.expandData?.forEach((expLoop) => {
          totLength.push(expLoop?.length?.name);
          totSize.push(expLoop?.size);
        });
      }
      parentData.expandData = expandArray?.map((element, inde) => {
        const quantityPerSizCol = element?.quantityPerSizCol;
        const pricePerUnit = element?.pricePerUnit;
        const totalPrice = roundingOff(element?.pricePerUnit * quantityPerSizCol, 4);
        if (!isBreakdown) {
          totLength.push(element?.length?.name);
          totSize.push(element?.size);
          sumOfTotalPrice = +sumOfTotalPrice + +totalPrice;
          sumOfQuantityPerSizCol = +sumOfQuantityPerSizCol + +quantityPerSizCol;
          sumPricePerUnit = +sumPricePerUnit + +pricePerUnit;
          element.totalPrice = totalPrice;
          const weightagePricePerUnit = quantityPerSizCol * pricePerUnit;
          totWeightagePricePerUnit = checkIsNanAndNumber(weightagePricePerUnit) + checkIsNanAndNumber(totWeightagePricePerUnit);
          totalQuantity = checkIsNanAndNumber(totalQuantity) + checkIsNanAndNumber(quantityPerSizCol);
        } else if (isBreakdown && inde === 0) {
          sumOfTotalPrice = +sumOfTotalPrice + +totalPrice;
          sumOfQuantityPerSizCol = +sumOfQuantityPerSizCol + +quantityPerSizCol;
          sumPricePerUnit = +sumPricePerUnit + +pricePerUnit;
          element.totalPrice = totalPrice;
        }
        totColourways.push(parentData?.colourway?.name);
        return element;
      });
      parentData.sizeRange = totSize
        .filter((item, index) => totSize.indexOf(item) === index)
        .map((vl) => {
          return { name: vl, label: vl };
        });
      parentData.lengthRange = totLength
        .filter((item, index) => totLength.indexOf(item) === index)
        .map((vl) => {
          return { name: vl, label: vl };
        });
      parentData.sumOfQuantityPerSizCol = sumOfQuantityPerSizCol;
      parentData.sumTotalPrice = sumOfTotalPrice;
      parentData.sumOfPricePerUnit = sumPricePerUnit;
      parentData.totWeightagePricePerUnit = totWeightagePricePerUnit / totalQuantity;
      return parentData;
    });
    // calculate overall sum or each total of columns
    const data = await calculateTotValues(updatedArray, [
      {
        key: 'sumOfQuantityPerSizCol',
        updateKey: 'overAllSumOfQuantityPerSizCol',
      },
      { key: 'sumTotalPrice', updateKey: 'overAllSumOfTotalPrice' },
      { key: 'sumOfPricePerUnit', updateKey: 'overAllSumOfPricePerUnit' },
    ]);
    set(copyState, averageCostingFieldpath().EXPAND_OVERALL_SUM_TOTAL_PRICE, data?.overAllSumOfTotalPrice);
    set(copyState, averageCostingFieldpath().EXPAND_OVERALL_SUM_QUANTITY_PER_COL_SIZ, data?.overAllSumOfQuantityPerSizCol);
    set(copyState, averageCostingFieldpath().EXPAND_OVERALL_SUM_PRICE_PER_UNIT, data?.overAllSumOfPricePerUnit);
    set(copyState, averageCostingFieldpath().TOTAL_AVERAGE_COLOURWAYS, [...new Set(totColourways)]);
    set(copyState, averageCostingFieldpath().TOTAL_AVERAGE_LENGTH, [...new Set(totLength)]);
    set(copyState, averageCostingFieldpath().TOTAL_AVERAGE_SIZES, [...new Set(totSize)]);
    set(copyState, averageCostingFieldpath().AVERAGE_COSTING_INFO, updatedArray);
    setProductCostingState((prevState) => ({ ...prevState, ...copyState }));
    set(copyState, averageCostingFieldpath().LOADER, false);
  };

  const calculateQuantities = async (copyState, colourwayId) => {
    const copyStates = copyState;
    let overAllSumOfQuantityPerSizCol = '0';
    const totLength = [];
    const totSize = [];
    const totColourways = [];
    const updatedArray = copyStates?.quantities?.quantitiesInfo?.map((parentData) => {
      const expandArray = parentData?.expandData;
      let sumOfQuantityPerSizCol = '0';
      if (isBreakdown) {
        parentData?.expandData?.forEach((expLoop) => {
          if (!isEmpty(expLoop?.length)) {
            totLength.push(expLoop?.length?.name);
          }
          totSize.push(expLoop?.size);
        });
      }
      parentData.expandData = expandArray?.map((data, ind) => {
        const { quantityPerSizCol } = data;
        if (!isBreakdown) {
          sumOfQuantityPerSizCol = +sumOfQuantityPerSizCol + +quantityPerSizCol;
          if (!isEmpty(data?.length)) {
            totLength.push(data?.length?.name);
          }
          totSize.push(data?.size);
        } else if (isBreakdown && ind === 0) {
          sumOfQuantityPerSizCol = +sumOfQuantityPerSizCol + +quantityPerSizCol;
        }
        totColourways.push(parentData?.colourway?.name);
        return data;
      });
      parentData.sizeRange = totSize
        .filter((item, index) => totSize.indexOf(item) === index)
        .map((vl) => {
          return { name: vl, label: vl };
        });
      parentData.lengthRange = totLength
        .filter((item, index) => totLength.indexOf(item) === index)
        .map((vl) => {
          return { name: vl, label: vl };
        });
      parentData.sumOfQuantityPerSizCol = sumOfQuantityPerSizCol;
      overAllSumOfQuantityPerSizCol = +overAllSumOfQuantityPerSizCol + +sumOfQuantityPerSizCol;
      if (colourwayId === parentData?.colourway?._id) {
        handleTestingModuleChange(copyStates, colourwayId, sumOfQuantityPerSizCol);
      }
      return parentData;
    });
    // calculate overall sum or each total of columns
    set(copyStates, quantitiesFieldpath().QUANTITES_INFO, updatedArray);
    set(copyState, quantitiesFieldpath().TOTAL_AVERAGE_COLOURWAYS, [...new Set(totColourways)]);
    set(copyState, quantitiesFieldpath().TOTAL_AVERAGE_LENGTH, [...new Set(totLength)]);
    set(copyState, quantitiesFieldpath().TOTAL_AVERAGE_SIZES, [...new Set(totSize)]);
    set(copyStates, 'quantities.overAllSumOfQuantityPerSizCol', overAllSumOfQuantityPerSizCol);
    setProductCostingState((state) => ({ ...state, ...copyStates }));
  };

  const handleTestingModuleChange = (state, colourId, sumOfQuantityPerSizCol) => {
    const copyState = state;
    const testingData = get(copyState, testingFieldpath().TESTING_INFO_DATA, []);
    if (checkArray(testingData)) {
      const updatedTestingData = [];
      for (const element of testingData) {
        if (element?.colourway?._id === colourId) {
          const pricePerColour = element?.totalPrice / sumOfQuantityPerSizCol;
          element.pricePerUnit = pricePerColour;
        }
        updatedTestingData.push(element);
      }
      set(copyState, 'testing.testingInfo', updatedTestingData);
      setProductCostingState((prevState) => ({ ...prevState, ...copyState }));
    }
  };

  useEffect(() => {
    return () => {
      dispatch(Action.setPreviousProductCostingData(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const manipualteDetailedCostingDataOnChange = async (state, suppid) => {
    const copyState = state;
    set(copyState, 'averageCosting', initialSetting?.averageCosting);
    const cloneBomList = bomCompoList;

    const copyBomList = [];
    for (const element of cloneBomList) {
      element.colourWayRefsData = element?.colourWayRefsData?.filter((vl) => {
        return vl?.colourRefsDataAsPerSuppliers?.some((colour) => colour?.tier1Supplier?._id === suppid);
      });
      copyBomList.push(element);
    }

    const updatedArray = [];
    const totSizes = sizeOptionsArr?.map((data) => data?.name);
    const totlegLengths = productLengths?.map((data) => data?.name);

    for (const element of copyBomList) {
      const setKeys = [
        { key: 'quantityPerSizCol', value: '' },
        { key: 'quantityUom', value: element.quantityUnitOfMeasure },
        { key: 'totalQuantityUom', value: null },
        { key: 'pricePerUnit', value: '' },
      ];
      if (Array.isArray(element.colourWayRefsData) && element.colourWayRefsData.length > 0) {
        const colourwayIds = [];
        // loop to get each bom component colourway data
        for (const childElement of element.colourWayRefsData) {
          const elementObj = {
            colourWay: childElement.colourWayId,
          };
          const colourRef = [];
          if (checkArray(childElement?.colourRefsDataAsPerSuppliers)) {
            for (const colourSupp of childElement.colourRefsDataAsPerSuppliers) {
              colourRef.push(colourSupp?.colourRef?.name);
            }
          }
          elementObj.colourRef = (colourRef || []).join(', ');
          colourwayIds.push(elementObj);
        }
        // set and manipulate the expand data based on each unique colours
        if (colourwayIds && colourwayIds?.length > 0) {
          const totColourways = colourwayIds?.map((data) => data?.colourWay);
          // set total at parent level at bomn compoennt level
          const parentKeys = [
            {
              key: 'totLength',
              value: totlegLengths,
            },
            {
              key: 'totSize',
              value: totSizes,
            },
            {
              key: 'totColourways',
              value: totColourways,
            },
          ];
          const manipullatedAverageData = await createDynamicGroupedArray(colourwayIds, sizeOptionsArr, productLengths, setKeys, parentKeys);
          // set total at parent level at expand data  compoennt level

          element.detailedCostingInfo = manipullatedAverageData;
          element.totLength = [...new Set(productLengths.map((data) => data?.name))];
          element.totSize = [...new Set(sizeOptionsArr.map((data) => data))];
          element.totColourways = [...new Set(colourwayIds.map((data) => data?.name))];
        }
      } else {
        const totColourways = colourwayOptionsArr.map((data) => data?.name);
        // set total at parent level at bomn compoennt level

        const parentKeys = [
          {
            key: 'totLength',
            value: totlegLengths,
          },
          {
            key: 'totSize',
            value: totSizes,
          },
          {
            key: 'totColourways',
            value: totColourways,
          },
        ];

        const manipullatedAverageData = await createDynamicGroupedArray(colourwayOptionsArr, sizeOptionsArr, productLengths, setKeys, parentKeys);
        element.detailedCostingInfo = manipullatedAverageData;
        // set total at parent level at expand data  compoennt level

        element.totLength = [...new Set(productLengths.map((data) => data?.name))];
        element.totSize = [...new Set(sizeOptionsArr.map((data) => data))];
        element.totColourways = [...new Set(colourwayOptionsArr.map((data) => data?.name))];
      }

      updatedArray.push(element);
    }
    set(copyState, 'detailedCosting.bomTypeArr', updatedArray);
    setProductCostingState((prevState) => ({ ...prevState, ...copyState }));
    return copyState;
  };

  const manipualtedProductCostingSaveData = async (data, type) => {
    let array = [];
    const updatedData = cloneData(data);
    switch (type) {
      case 'averageCosting':
      case 'quantities':
        array = updatedData.map((element) => {
          element.colourway = element?.colourway?._id;
          element.expandData = element?.expandData?.map((expElement) => {
            expElement.colourway = expElement?.colourway?._id;
            expElement.length = expElement?.length?._id || null;
            if (isBreakdown) {
              expElement.pricePerUnit = element?.expandData[0]?.pricePerUnit;
              expElement.quantityPerSizCol = element?.expandData[0]?.quantityPerSizCol;
              expElement.totalPrice = element?.expandData[0]?.totalPrice;
            }
            return expElement;
          });
          return element;
        });
        break;
      case 'landedInfo':
        if (isBreakdown) {
          const newCloneddat = cloneData(updatedData);
          const sizeRange = newCloneddat[0]?.sizeRange || [];
          const lengthRange = newCloneddat[0]?.lengthRange || [];
          const newBreakdownLandedInfoArray = [];
          for (const val of newCloneddat) {
            const newVal = cloneDeep(val);
            if (Array.isArray(sizeRange) && sizeRange.length > 0 && Array.isArray(lengthRange) && lengthRange.length > 0) {
              for (const siz of sizeRange) {
                for (const len of lengthRange) {
                  const obj = {
                    ...newVal,
                  };
                  obj.size = siz;
                  obj.length = len?._id;
                  obj.colourway = obj?.colourway?._id || obj?.colourWay?._id;
                  newBreakdownLandedInfoArray.push(cloneDeep(obj));
                }
              }
            } else if (Array.isArray(lengthRange) && lengthRange.length > 0) {
              for (const len of lengthRange) {
                const obj = {
                  ...newVal,
                };
                obj.length = len?._id;
                obj.colourway = obj?.colourway?._id || obj?.colourWay?._id;
                newBreakdownLandedInfoArray.push(cloneDeep(obj));
              }
            } else if (Array.isArray(sizeRange) && sizeRange.length > 0) {
              for (const siz of sizeRange) {
                const obj = {
                  ...newVal,
                };
                obj.size = siz;
                obj.colourway = obj?.colourway?._id || obj?.colourWay?._id;
                newBreakdownLandedInfoArray.push(cloneDeep(obj));
              }
            }
          }
          if (Array.isArray(newBreakdownLandedInfoArray) && newBreakdownLandedInfoArray.length > 0) {
            array = newBreakdownLandedInfoArray;
          }
        } else {
          array = updatedData.map((element) => {
            element.colourway = element?.colourway?._id || element?.colourWay?._id;
            element.length = element?.length?._id;
            return element;
          });
        }

        break;
      case 'detailedCosting':
        array = updatedData.map((element) => {
          element.colourway = element?.colourway._id;
          element.expandData = element?.expandData.map((expElement) => {
            expElement.colourway = expElement?.colourway?._id;
            expElement.length = expElement?.length?._id || null;
            expElement.quantityUom = expElement?.quantityUom?._id;

            if (isBreakdown) {
              expElement.pricePerUnit = element?.expandData[0]?.pricePerUnit;
              expElement.quantityPerSizCol = element?.expandData[0]?.quantityPerSizCol;
              expElement.totalPrice = element?.expandData[0]?.totalPrice;
            }
            return expElement;
          });
          return element;
        });
        break;
      case 'testing':
        array = updatedData.map((element) => {
          element.colourway = element?.colourway?._id;
          element.testingCode = element?.testingCode?._id;
          element.colourRef = element?.colourRef?._id;
          return element;
        });
        break;
      case 'additional':
        array = updatedData.map((element) => {
          element.colourway = element?.colourway?.map((value) => value._id);
          element.quantityUom = element?.quantityUom?._id;
          return element;
        });
        break;
      case 'grandTotal':
        array = updatedData?.map((element) => {
          element.colourway = element?.colourway?._id;
          element.length = element?.length?._id;
          return element;
        });
        break;
      default:
        break;
    }
    return array;
  };

  const handleLandedInfoModule = async (res, copyState, controlSetState) => {
    const updatedArray = [];
    if (Array.isArray(res?.landedInfo) && res?.landedInfo.length > 0) {
      let columnArr = [];
      if (Array.isArray(res?.landedInfo[0]?.landedInfoRowArr) && res?.landedInfo[0]?.landedInfoRowArr?.length > 0) {
        columnArr = res?.landedInfo[0]?.landedInfoRowArr;
      }
      for (const land of res.landedInfo) {
        land.landedCost = '';
        land.sellingPrice = '';
        land.profit = '';
        land.marginPercent = '';
        land.markup = '';
        land.vat = res?.vat;
        land.landedInfoRowArr = land?.landedInfoRowArr?.map((ele) => {
          return {
            ...ele,
            colName: ele?.title,
            colValue: ele?.tempValue,
          };
        });
        updatedArray.push(land);
      }
      set(copyState, landedInfoFieldPath().LANDED_INFO_DYNAMIC_COLUMN, columnArr);
    }
    const updatedLandedInfo = await grandTotalLandedInfoCalculation(grandTotal, updatedArray);
    const updateArrays = await calculateProfit(updatedLandedInfo);
    const updatddd = await setBreakDownLandedInfo(updateArrays);
    set(copyState, landedInfoFieldPath().LANDED_INFO_DATA, updatddd);
    if (controlSetState) {
      return copyState;
    }
    setProductCostingState((prevState) => ({ ...prevState, ...copyState }));
  };

  const handleAdditonalModule = (res, copyState, controlSetState, controlDetailedCosting) => {
    if ((detailedCostingActive || controlDetailedCosting) && Array.isArray(res?.additionalInfo) && res?.additionalInfo.length > 0) {
      let response = res?.additionalInfo;
      response = response.map((data) => {
        return {
          ...data,
          colourway: null,
          quantityUom: null,
          totalQuantityUom: null,
          quantityPerUnit: '',
          pricePerUnit: '',
          totalQuantity: '',
          pricePerUoM: '',
          quantityPerColSizLen: '',
        };
      });
      set(copyState, additionalFieldPath().SELECTED_TEMP_ADDTIONAL_DATA, response);
    } else if (detailedCostingActive || controlDetailedCosting) {
      set(copyState, 'additional', {
        additionalInfo: [
          {
            colourway: null,
            quantityUom: null,
            totalQuantityUom: null,
            quantityPerUnit: '',
            pricePerUnit: '',
            title: '',
            totalQuantity: '',
            pricePerUoM: '',
            quantityPerColSizLen: '',
          },
        ],
      });
    }
    if (controlSetState) {
      return copyState;
    }
    setProductCostingState((prevState) => ({ ...prevState, ...copyState }));
  };

  const handleAverageCosting = async () => {
    const state = productCostingstate;
    set(state, 'detailedCosting', initialSetting?.detailedCosting);
    set(state, 'quantities', initialSetting?.quantities);
    set(state, 'testing', initialSetting?.testing);
    set(state, 'additional', initialSetting?.additional);

    const setKeys = [
      { key: 'quantityPerSizCol', value: '' },
      { key: 'pricePerUnit', value: '' },
    ];
    const manipullatedAverageData = await createDynamicGroupedArray(colourwayOptionsArr, sizeOptionsArr, productLengths, setKeys);

    set(state, averageCostingFieldpath().AVERAGE_COSTING_INFO, manipullatedAverageData);
    set(
      state,
      averageCostingFieldpath().TOTAL_AVERAGE_SIZES,
      sizeOptionsArr.map((data) => data?.name),
    );
    set(
      state,
      averageCostingFieldpath().TOTAL_AVERAGE_LENGTH,
      productLengths.map((data) => data?.name),
    );
    set(
      state,
      averageCostingFieldpath().TOTAL_AVERAGE_COLOURWAYS,
      colourwayOptionsArr.map((data) => data?.name),
    );
    setProductCostingState((prevState) => ({ ...prevState, ...state }));
  };

  const handleDetailedCosting = async () => {
    const copyState = productCostingstate;
    const data = await manipualteDetailedCostingDataOnChange(copyState, supplierId?._id);
    await handleQuantities(data);
    await handleTesting(data);
    if (productTemplate) {
      const res = await dispatch(action.getCostingTemplateDetailsById(productTemplate._id));
      await handleAdditonalModule(res, data, undefined, true);
    }
  };

  const handleQuantities = async (copyState) => {
    const setKeys = [{ key: 'quantityPerSizCol', value: '' }];
    const manipultedQuantitesData = await createDynamicGroupedArray(colourwayOptionsArr, sizeOptionsArr, productLengths, setKeys);
    set(copyState, quantitiesFieldpath().QUANTITES_INFO, manipultedQuantitesData);
    set(
      copyState,
      quantitiesFieldpath().TOTAL_AVERAGE_SIZES,
      sizeOptionsArr.map((data) => data.name),
    );
    set(
      copyState,
      quantitiesFieldpath().TOTAL_AVERAGE_LENGTH,
      productLengths.map((data) => data.name),
    );
    set(
      copyState,
      quantitiesFieldpath().TOTAL_AVERAGE_COLOURWAYS,
      colourwayOptionsArr.map((data) => data.name),
    );

    setProductCostingState((prevState) => ({ ...prevState, ...copyState }));
  };

  const handleTesting = async (copyState) => {
    const testing = [];
    TestingLibraries.forEach((test) => {
      const obj = {
        colourway: null,
        colourRef: test?.colour,
        testingCode: test,
        testingDesc: test.description,
        testingType: test.type,
        totalPrice: '',
        isExcluded: false,
        isChangedBySupplierTotalPrice: false,
        isChangedBySupplierPricePerUnit: false,
        pricePerUnit: '',
        bomComponent: test?.bomComponent?.referenceCode,
      };
      testing.push(obj);
    });
    set(copyState, testingFieldpath().TESTING_INFO_DATA, testing);
    setProductCostingState((prevState) => ({ ...prevState, ...copyState }));
  };

  const calculateProfit = async (array) => {
    if (Array.isArray(array) && array.length > 0) {
      const newArray = [];
      for (const data of array) {
        const landedCost = checkIsNanAndNumber(data?.pricePerUnitIncoConverted);
        const sellingPrice = checkIsNanAndNumber(data?.sellingPrice);
        let percent = 0;
        let amount = 0;
        if ('landedInfoRowArr' in data && Array.isArray(data.landedInfoRowArr) && data.landedInfoRowArr.length > 0) {
          data?.landedInfoRowArr.forEach((info) => {
            if (info?.type === 'source' && info?.subLocation?.key === 'Number_percentage') {
              percent = +percent + +info.colValue;
            } else if (info.type === 'amount' || info?.type === 'source') amount = checkIsNanAndNumber(amount) + checkIsNanAndNumber(info.colValue);
            else if (info.type === 'percentage') percent = +percent + +info.colValue;
          });
        }
        const percentageValue = landedCost * (percent / 100);
        const pricePerUnitLanded =
          checkIsNanAndNumber(data?.pricePerUnitIncoConverted) +
          checkIsNanAndNumber(data?.brandFee) +
          checkIsNanAndNumber(data?.supplierFee) +
          checkIsNanAndNumber(amount) +
          checkIsNanAndNumber(percentageValue);
        data.pricePerUnitLanded = roundOff(pricePerUnitLanded, 4) || 0;
        data.totalLanded = roundOff(pricePerUnitLanded * data?.quantityPerSizCol, 4) || 0;
        const vat = data?.vat ? data?.vat : 0;
        const netSalesValue = sellingPrice / (1 + vat / 100);
        data.netSalesValue = roundOff(netSalesValue, 4) || 0;
        const profit = (checkIsNanAndNumber(netSalesValue) - checkIsNanAndNumber(pricePerUnitLanded)).toString();
        if (profit && netSalesValue > 0) {
          const marginPercent = ((checkIsNanAndNumber(profit) / checkIsNanAndNumber(netSalesValue)) * 100).toString();
          data.marginPercent = roundOff(marginPercent, 4);
        }
        let markup = 0;
        if (checkIsNanAndNumber(pricePerUnitLanded) > 0) {
          markup = (checkIsNanAndNumber(netSalesValue) / checkIsNanAndNumber(pricePerUnitLanded)).toString();
        }
        data.markup = roundOff(markup, 4);
        data.profit = roundOff(profit, 4);
        newArray.push(data);
      }
      return newArray;
    }
  };

  const grandTotalLandedInfoCalculation = async (grandTotal, landedInfoArr) => {
    const cloneLandedInfo = cloneDeep(landedInfoArr);
    const grandCombinationData = flatMap(grandTotal.map((val) => val?.expandData));
    const newLandedArray = [];
    if (isArray(grandCombinationData) && grandCombinationData.length > 0) {
      for (const val of cloneLandedInfo) {
        const colours = val.colourway ? get(val, 'colourway._id', null) : get(val, 'colourWay._id', null);
        const sizess = get(val, 'size', '');
        const lenghtss = get(val, 'length._id', null);
        const customSectionColourSize = {
          colourWayId: isEmpty(colours) ? null : colours?.toString(),
          size: !sizess.trim() ? '' : sizess,
          lengthId: isEmpty(lenghtss) ? null : lenghtss?.toString(),
        };
        const getData = grandCombinationData?.find((val) => {
          const colours = val.colourway ? get(val, 'colourway._id', null) : get(val, 'colourWay._id', null);
          const sizess = get(val, 'size', '');
          const lenghtss = get(val, 'length._id', null);
          const obj = {
            colourWayId: isEmpty(colours) ? null : colours?.toString(),
            size: !sizess.trim() ? '' : sizess,
            lengthId: isEmpty(lenghtss) ? null : lenghtss?.toString(),
          };
          return isEqual(customSectionColourSize, obj);
        });
        if (getData) {
          const brandFee = isArray(productDetails?.brand) && productDetails?.brand?.length > 0 ? checkIsNanAndNumber(productDetails?.brand[0]?.royaltyFee) : 0;
          const pricePerUnitIncoterm = checkIsNanAndNumber(getData?.pricePerUnit);
          const secondaryCurrency = productExchnageRate?.defaultCurrencyValue ? productExchnageRate?.defaultCurrencyValue : 0;
          const secondaryCurrencyValue = internalState?.landedExchangeRateInformation?.companyCurrencyValue
            ? internalState?.landedExchangeRateInformation?.companyCurrencyValue
            : secondaryCurrency;
          const primaryCurrencyValue = internalState?.landedExchangeRateInformation?.exchangedRate
            ? internalState?.landedExchangeRateInformation?.exchangedRate
            : internalState?.primaryCurrValue;
          const pricePerUnitIncoConverted = convertedCurrValue(pricePerUnitIncoterm, primaryCurrencyValue, secondaryCurrencyValue);
          const totalIncoterm = checkIsNanAndNumber(getData?.totalPrice);
          const totalIncoConverted = convertedCurrValue(totalIncoterm, primaryCurrencyValue, secondaryCurrencyValue);
          const supplierFee = checkIsNanAndNumber(supplierId?.companies?.agentFee);
          const supplierFeePercent = (pricePerUnitIncoConverted * supplierFee) / 100;
          const brandFeePercent = (pricePerUnitIncoConverted * brandFee) / 100;
          val.supplierFee = roundOff(supplierFeePercent, 4);
          val.brandFee = roundOff(brandFeePercent, 4);
          val.pricePerUnitInco = roundOff(pricePerUnitIncoterm, 4);
          val.totalInco = roundOff(totalIncoterm, 4);
          val.quantityPerSizCol = getData?.quantityPerSizCol;
          val.pricePerUnitIncoConverted = roundOff(pricePerUnitIncoConverted, 4);
          val.totalIncoConverted = roundOff(totalIncoConverted, 4);
        }
        newLandedArray.push(val);
      }
      return newLandedArray;
    }
    return cloneLandedInfo;
  };

  const setBreakDownLandedInfo = async (currlandedInfo) => {
    if (!isBreakdown) return currlandedInfo;
    if (isBreakdown) {
      let sizeRange = [];
      let lengthRange = [];
      if (Array.isArray(currlandedInfo) && currlandedInfo.length > 0) {
        for (const land of currlandedInfo) {
          if (land?.size) {
            sizeRange.push(land?.size);
          }
          if (land?.length) {
            lengthRange.push(land?.length);
          }
        }
        return _.chain(currlandedInfo)
          .groupBy((item) => {
            if (item?.colourway && item?.colourway?._id) {
              return `${item?.colourway?._id}`;
            }
            if (item?.colourWay && item?.colourWay?._id) {
              return `${item?.colourWay?._id}`;
            }
          })
          .map(function (items) {
            const obj = { ...items[0] };
            if (Array.isArray(sizeRange) && sizeRange.length > 0) {
              sizeRange = sizeRange?.filter((v, i, a) => a.findIndex((v2) => v2 === v) === i);
              obj.sizeRange = sizeRange;
            }
            if (Array.isArray(lengthRange) && lengthRange.length > 0) {
              lengthRange = lengthRange?.filter((v, i, a) => a.findIndex((v2) => v2?.name === v?.name) === i);
              obj.lengthRange = lengthRange;
            }
            return obj;
          })
          .value();
      }
      return [];
    }
  };
  return {
    calculateAvrageCosting,
    calculateQuantities,
    manipualteDetailedCostingDataOnChange,
    manipualtedProductCostingSaveData,
    handleLandedInfoModule,
    handleAdditonalModule,
    handleAverageCosting,
    handleDetailedCosting,
    calculateProfit,
    grandTotalLandedInfoCalculation,
    setBreakDownLandedInfo,
  };
}
